"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockFerroSwapFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
        ],
        name: "getTokenIndex",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        name: "indexToToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "tokens",
                type: "address[]",
            },
            {
                internalType: "uint8[]",
                name: "indexes",
                type: "uint8[]",
            },
        ],
        name: "setTokenIndexes",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "tokenIndexFrom",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "tokenIndexTo",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "dx",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minDy",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tokenToIndex",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class MockFerroSwapFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockFerroSwapFactory = MockFerroSwapFactory;
MockFerroSwapFactory.bytecode = _bytecode;
MockFerroSwapFactory.abi = _abi;
//# sourceMappingURL=MockFerroSwapFactory.js.map